module.exports = __webpack_public_path__ + "static/media/smile-beam.2570156f.svg";